import React from "react";
import { Path, UseFormReturn } from "react-hook-form";
import getValue from "lodash/get";

export function useFormField<T>(form: UseFormReturn<T>, serverErrors: Partial<Record<keyof T, string>> = {}) {
  const getFieldProps = React.useCallback(
    (name: Path<T>) => {
      return {
        ...form.register(name),
        error: getValue(form.formState.errors, name)?.message ?? getValue(serverErrors, name),
      };
    },
    [form, serverErrors]
  );

  return { getFieldProps };
}
